<template>

		<main class="">
			<div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
				Hi
			</div>
		</main>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import PreviewHeader from '@/Layouts/PreviewHeader'

export default {
	// Using the shorthand
	layout: PreviewHeader,
	// layout: [HeaderNav, LandingHeader],
}
</script>


<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { ref, reactive, computed } from 'vue';



const props = defineProps({
	icons: Object,
	canLogin: Boolean,
	canRegister: Boolean,
})

</script>